import { render, staticRenderFns } from "./imapConfig.vue?vue&type=template&id=8ea927e4&"
import script from "./imapConfig.vue?vue&type=script&lang=js&"
export * from "./imapConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports